import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/*
 * DDT-4042: on mobile the Essentielle upsell pop-up is a bottom sheet, and the design gives
 * it two ways out — the X, and a drag down on the band at the top of the sheet. The slide-up
 * and the resting position are CSS; this only follows the finger while a drag is in progress.
 */
/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['sheet', 'close'];

    // Below the theme's md breakpoint the dialog is the bottom sheet; above it, a centered box.
    static MOBILE_MAX_WIDTH = 767.98;

    // A third of the sheet, so a hesitant drag springs back instead of closing.
    static CLOSE_RATIO = 1 / 3;

    connect() {
        this.dragging = false;
        this.startY = 0;
        this.distance = 0;
    }

    start(event) {
        if (!this.isBottomSheet()) {
            return;
        }

        this.dragging = true;
        this.startY = event.clientY;
        this.distance = 0;
        this.sheetTarget.classList.add('upsell-modal__content--dragging');
    }

    move(event) {
        if (!this.dragging) {
            return;
        }

        // Downwards only: dragging up must not lift the sheet off the bottom of the screen.
        this.distance = Math.max(0, event.clientY - this.startY);
        this.sheetTarget.style.transform = `translateY(${this.distance}px)`;
    }

    end() {
        if (!this.dragging) {
            return;
        }

        this.dragging = false;
        this.sheetTarget.classList.remove('upsell-modal__content--dragging');

        if (this.distance > this.sheetTarget.offsetHeight * this.constructor.CLOSE_RATIO) {
            this.close();

            return;
        }

        this.sheetTarget.style.transform = '';
    }

    /*
     * Two different things can have opened this pop-up: the controller next to us, which keeps
     * its own Bootstrap Modal instance and shows it, and the ~20 `data-bs-toggle="modal"` triggers,
     * which make a second instance of their own under jQuery's `bs.modal` data. Only the instance
     * that ran show() will hide(), and we cannot tell from here which one that was — so dismiss
     * the way the X does. Bootstrap binds that handler on whichever instance opened the sheet.
     */
    close() {
        // The sheet keeps the offset it was dragged to, so it carries on down with the dialog
        // instead of springing back under it; it is reset once the pop-up is really hidden.
        $(this.element).one('hidden.bs.modal', () => {
            this.sheetTarget.style.transform = '';
        });

        this.closeTarget.click();
    }

    isBottomSheet() {
        return window.matchMedia(`(max-width: ${this.constructor.MOBILE_MAX_WIDTH}px)`).matches;
    }
}
